import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import menuPortalProps from 'helpers/reactSelectPortal';
import { transferSiteOfficeBooking } from 'redux/booking/car/carBookingSlice';
import { getActiveSites } from 'redux/organization/siteSlice';
import { Modal, Button, Alert } from 'components/common';

const TransferSiteOfficeConfirm = ({ showModal, setshowModal, transaction }) => {
  const { control, handleSubmit, formState: { errors } } = useForm();
  const { activeData: siteData = [] } = useSelector((state) => state.organization_site);
  const dispatch = useDispatch();

  const siteOptions = siteData
    .filter((item) => item.car_booking === true)
    .map((item) => ({ value: item.id, label: item.name }));

  useEffect(() => {
    dispatch(getActiveSites());
  }, [dispatch]);

  const closeModal = () => setshowModal(false);

  const onSubmit = (data) => {
    try {
      dispatch(transferSiteOfficeBooking({ transactionId: transaction?.id, data }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Transfer site office"
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button size="sm" type="submit" form="transfer-site-office-form" variant="primary">Transfer</Button>
        </>
      )}
    >
      <form id="transfer-site-office-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="warning" className="tw-mb-4">
          {`Are you sure to transfer the ${transaction.site_name} site for booking number ${transaction.booking_number}?`}
        </Alert>

        <label className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">To Site</label>
        <Controller
          control={control}
          name="site_id"
          rules={{ required: { value: true, message: 'Site must be required' } }}
          render={({ field }) => (
            <Select
              closeMenuOnSelect
              options={siteOptions}
              placeholder="Select..."
              classNamePrefix="react-select" {...menuPortalProps}
              value={siteOptions.find((option) => option.value === field.value) || null}
              onChange={(selectedOption) => field.onChange(selectedOption.value)}
            />
          )}
        />
        {errors.site_id && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{errors.site_id.message}</p>}
      </form>
    </Modal>
  );
};

TransferSiteOfficeConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  transaction: PropTypes.object.isRequired,
};

export default TransferSiteOfficeConfirm;
